import { createRoot } from 'react-dom/client';
import { StrictMode, Suspense } from 'react';
import { I18nProvider, createI18n, search } from '@bino/utils/i18next';
import { Pending } from '@bino/utils/components/pending';
import { SearchPage, type SearchPageProps } from './pages/search';
import { ProgrammeSearchPage } from './pages/programme-search';
import { createBrowserRouter, RouterProvider } from 'react-router';

const i18n = createI18n(search);

type RenderAppProps = SearchPageProps;

export const renderApp = (id: string, props: RenderAppProps) => {
    const container = document.getElementById(id);
    if (!container) return;

    const root = createRoot(container);
    const router = createBrowserRouter([
        {
            path: '*',
            element: <SearchPage {...props} />,
        },
    ]);
    root.render(
        <StrictMode>
            <Suspense fallback={<Pending />}>
                <I18nProvider i18n={i18n}>
                    <RouterProvider router={router} />
                </I18nProvider>
            </Suspense>
        </StrictMode>,
    );
};

export const renderProgrammeSearchApp = (id: string) => {
    const container = document.getElementById(id);
    if (!container) return;

    const root = createRoot(container);
    const router = createBrowserRouter([
        {
            path: '*',
            element: <ProgrammeSearchPage />,
        },
    ]);
    root.render(
        <StrictMode>
            <Suspense fallback={<Pending />}>
                <I18nProvider i18n={i18n}>
                    <RouterProvider router={router} />
                </I18nProvider>
            </Suspense>
        </StrictMode>,
    );
};
